
import { defineComponent, onBeforeMount, ref } from 'vue';
import { invokeGetUserRole } from '../../utils/admin/master_service';
import { invokeGetEvents, invokeSendEmailToLearner } from '../../utils/admin/send_email_to_learner_service';

export default defineComponent({
  name: 'SendEmailToUser',
  setup() {
    const renderReady = ref(true);
    const selectedEvents = ref();
    const errorMessage = ref();
    const userRole = ref();
    const showScreen = ref(true);
    const showSuccessMessage = ref(false);
    const resMessage = ref();
    const showErrorMessage = ref(false);
    const events = ref();
    const taskIdToSendEmail = ref();
    const sendEmailToLearner = async () => {
      renderReady.value = false;
      if (!selectedEvents.value) {
        console.log('Please Select Events');
      } else if (!taskIdToSendEmail.value) {
        console.log('Please Enter Task Id');
      } else {
        const emailObj = {
          leaner_task_id: taskIdToSendEmail.value,
          event_type: selectedEvents.value,
        };
        console.log(`selected Events ${selectedEvents.value} and Task Id ${taskIdToSendEmail.value}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const emailRes: any = await invokeSendEmailToLearner('/email/learner_task', emailObj);
        resMessage.value = emailRes.msg;
        showSuccessMessage.value = true;
        taskIdToSendEmail.value = '';
        selectedEvents.value = '';
        // console.log(`showSuccessMessage.value ${JSON.stringify(res)}`);
        setTimeout(() => {
          showSuccessMessage.value = false;
        }, 2000);
        console.log('Email Send Response', emailRes);
      }
      renderReady.value = true;
    };
    const getAllEvents = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const eventRes: any = await invokeGetEvents('/event');
      // const filterObject = eventRes.events;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      // const uniqueObject = filterObject.filter((v: any, i: any, a: any) => a.findIndex((v2: any) => v2.id === v.id) === i);
      // console.log('unidque object', uniqueObject);
      events.value = eventRes.events;
      console.log('events', events.value);
    };
    onBeforeMount(async () => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const role: any = await invokeGetUserRole('/getUserRole');
        userRole.value = role.user_roles;
        if (userRole.value.length > 0) {
          if (userRole.value.includes('System Admin')) {
            showScreen.value = true;
            await getAllEvents();
          } else {
            showScreen.value = false;
          }
        }
        renderReady.value = true;
        // userRole.value = localStorage.getItem('user_roles') ? localStorage.getItem('user_roles') : [];
        // if (userRole.value.length > 0) {
        //   if (userRole.value.includes('System Admin')) {
        //     showScreen.value = true;
        //   }
        // }
      } catch (error) {
        console.log(error);
      }
      // userRole.value = localStorage.getItem('user_roles') ? localStorage.getItem('user_roles') : [];
      // if (userRole.value.length > 0) {
      //   if (userRole.value.includes('System Admin') || userRole.value.includes('System Admin View Access')) {
      //     showScreen.value = true;
      //   }
      // }
    });
    return {
      renderReady,
      selectedEvents,
      errorMessage,
      showScreen,
      resMessage,
      showErrorMessage,
      showSuccessMessage,
      taskIdToSendEmail,
      events,
      sendEmailToLearner,
    };
  },
});
